import React from 'react';
import AppStatusScreen from './AppStatusScreen';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AppErrorBoundary:', error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const details = this.state.error?.message
      ? `Техническая деталь: ${this.state.error.message}`
      : '';

    return (
      <AppStatusScreen
        mode="error"
        title="Похоже, раздел временно недоступен"
        description="Что-то пошло не так при открытии экрана. Попробуйте обновить страницу или вернуться на главную."
        details={details}
        actions={[
          {
            kind: 'reload',
            label: 'Обновить страницу',
            onClick: () => window.location.reload()
          },
          {
            kind: 'home',
            label: 'На главную',
            tone: 'secondary',
            onClick: () => {
              window.location.hash = '#/';
              window.location.reload();
            }
          }
        ]}
      />
    );
  }
}

export default AppErrorBoundary;
